module.exports = __webpack_public_path__ + "images/img_3_3-9d7d89e967.png";